'use client'

import { useEffect, useMemo, useRef } from 'react'

import { useFetch } from '@marketplace-web/shared/api-client'
import { getCatalogFacetedCategories } from '@marketplace-web/domain/catalog-data'

import { useCatalogContext } from '../CatalogProvider'
import Context, { ContextType } from './FacetedCategoriesContext'

const FacetedCategoriesProvider = ({ children }: { children: JSX.Element }) => {
  const {
    state: {
      filters,
      dynamicFilters: { selectedDynamicFilters },
      general: { filtersChangeCount },
    },
  } = useCatalogContext()

  const filtersRef = useRef(filters)
  filtersRef.current = filters

  const selectedDynamicFiltersRef = useRef(selectedDynamicFilters)
  selectedDynamicFiltersRef.current = selectedDynamicFilters

  const { data, fetch } = useFetch(getCatalogFacetedCategories)

  useEffect(() => {
    if (filtersChangeCount < 1) return

    fetch({
      ...filtersRef.current,
      selectedDynamicFilters: selectedDynamicFiltersRef.current,
    })
  }, [fetch, filtersChangeCount])

  const value = useMemo<ContextType>(() => {
    return {
      categories: data?.categories,
    }
  }, [data])

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export default FacetedCategoriesProvider
